import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { onCLS, onINP, onLCP, onFCP, onTTFB } from 'web-vitals';
import App from './App';
import { trackWebVital } from './lib/analytics';
import './index.css';
import './i18n'; // initialise i18next (must be imported before App renders)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
);

// Register service worker for PWA support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => { /* sw registration failed, non-critical */ });
  });
}

// Core Web Vitals real-user monitoring → Plausible Custom Events (SEOADV-05)
onCLS(trackWebVital);
onINP(trackWebVital);
onLCP(trackWebVital);
onFCP(trackWebVital);
onTTFB(trackWebVital);
